import React from "react";
import { FormattedMessage } from "react-intl";
import { TextValidationField } from "../fields/TextField";
import { usernameValidator } from "./UsernameValidator";
import PropTypes from "prop-types";

export const UsernameEntry = (props) => {

  return (
    <TextValidationField
      label={<FormattedMessage id="login.userId" defaultMessage="User ID" description="Login form user input" />}
      name="userId"
      validator={usernameValidator}
      {...props}
    />
  );
};


UsernameEntry.propTypes = {
  onChange: PropTypes.func,
  externalValue: PropTypes.string,
};

